 
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/siteSubjects';
import { actions } from './SiteSubjectsList.slice';
import {
  SiteSubjectsListCreateSubjectAction,
  SiteSubjectDetailsFetchAction,
  SiteSubjectsListFetchAction,
} from './SiteSubjectsList.types';
import { Resp, dispatch } from '../helpers';
import { runToast } from '../tools';
import axios from 'axios';
import { setCurrentPage } from '@restore/paginationAndSort/paginationAndSort.slice';

export const messages = {
  createNewSubject: 'Creating new subject',
  createNewSubjectSuccess: 'New subject created successfully',
  createNewSubjectFailure: 'Failed to create new subject',
};

export function* fetchSiteSubjectsListWorker(
  action: SiteSubjectsListFetchAction
) {
  try {
    const { clinicalTrialId, siteId, args } = action.payload;
    const response: Resp<typeof api.fetchSubjectsBySite> = yield call(
      api.fetchSubjectsBySite,
      siteId,
      clinicalTrialId,
      args,
      args?.patientCode
    );
    yield dispatch(actions.fetchSiteSubjectsListSuccess(response));
  } catch (error) {
    yield dispatch(actions.fetchSiteSubjectsListFailure(error as Error));
  }
}

export function* fetchSiteSubjectDetailsWorker(
  action: SiteSubjectDetailsFetchAction
) {
  const { clinicalTrialId, patientId, siteId } = action.payload;
  const response: Resp<typeof api.getSubjectDetails> = yield call(
    api.getSubjectDetails,
    { clinicalTrialId, patientId, siteId }
  );
  try {
    yield dispatch(actions.fetchSiteSubjectDetailsSuccess(response?.data));
  } catch (error) {
    yield dispatch(actions.fetchSiteSubjectsDetailsFailure(error as Error));
  }
}

export function* createNewSubjectWorker(
  action: SiteSubjectsListCreateSubjectAction
) {
  try {
    const { clinicalTrialId, data, siteId } = action.payload;
    const response: Resp<typeof api.createSubject> = yield call(
      api.createSubject,
      data,
      clinicalTrialId,
      siteId
    );
    yield call(runToast, 'success', messages.createNewSubjectSuccess);
    yield dispatch(actions.createNewSubjectSuccess(response.data));

    yield dispatch(setCurrentPage({ listName: 'subjectList', newPage: 1 }));
    yield dispatch(actions.onNewlyCreatedSubject(data.patientCode));
  } catch (e) {
    yield dispatch(actions.createNewSubjectFailure(e as Error));
    if (axios.isAxiosError(e) && e.response?.status === 409) {
      yield call(
        runToast,
        'error',
        e.response?.data?.detail ?? messages.createNewSubjectFailure
      );
      return;
    }
    yield call(runToast, 'error', messages.createNewSubjectFailure);
  }
}

export function* SiteSubjectsListSaga() {
  yield takeLatest(
    actions.fetchSiteSubjectsList.type,
    fetchSiteSubjectsListWorker
  );
  yield takeLatest(actions.createNewSubject.type, createNewSubjectWorker);
  yield takeLatest(
    actions.fetchSiteSubjectDetails.type,
    fetchSiteSubjectDetailsWorker
  );
}
